import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle} from '../Common/style'

class InventoryRelocations extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchInventoryRelocations();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventoryRelocations is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.inventoryRelocations;
        if (nextProps.inventoryRelocations && nextProps.inventoryRelocations != this.props.inventoryRelocations) {
            this.setState({
                rows: nextProps.inventoryRelocations
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set inventoryRelocations being selected to be currentInventoryRelocation and navigate user to the edit page

    setCurrentInventoryRelocation(e) {
        e.preventDefault();
        const currentInventoryRelocation = this.state.selectedRows[0];
        this.props.resetCurrentInventoryConvert();
        this.props.selectInventoryRelocation(currentInventoryRelocation);
        this.context.router.push('/inventories/relocation/' + currentInventoryRelocation.WarehouseRelocation_id)
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventoryRelocation();
        this.props.resetCurrentInventoryConvert();
        this.context.router.push('/inventories/relocation/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Column difinition

            const columns = [
                {
                    key: 'WarehouseRelocationNum',
                    name: <Translate value="record_relocation_no" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    locked: true
                },
                {
                    key: 'CreateTime',
                    name: <Translate value="create_date" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'PostingDate',
                    name: <Translate value="relocation_date" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                },
                {
                    key: 'Modify_Username',
                    name: <Translate value="relocate_user" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    locked: true
                },
                {
                    key: 'Note',
                    name: <Translate value="note" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRelocations-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehouseRelocation_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        onRowUpdated={handleRowUpdated}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_relocations" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories"  className="btn btn-green marginLeftStyle" ><em className="fa fa-mail-reply"/></Link>
                    <Button className="btn btn-primary marginLeftStyle"  onClick={(e) => this.clickNew(e) } disabled={this.checkPermission("add_warehouse_relocation")}>
                        <em className="fa fa-plus marginRightStyle" /><Translate value="create_inventory_relocation_sheet" />
                    </Button>
                    <div className="pull-right">
                        <Button className="btn btn-primary marginLeftStyle" >
                            <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                        </Button>
                        <Button className="btn btn-primary marginLeftStyle" >
                            <em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                        </Button>
                        <Button
                          className="btn btn-primary marginLeftStyle"
                          onClick={(event) => {this.setCurrentInventoryRelocation(event)}}>
                            <em className="fa fa-pencil marginRightStyle" /><Translate value="edit" />
                        </Button>
                    </div>
                </Col></Row>
                <br/>
                {this.renderTable() }
            </ContentWrapper>
        );
    }
}



export default InventoryRelocations;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryRelocations.jsx